import _ from 'lodash'
export default function buildersInProperties(builders, properties) {
	let bids = []
	_.forEach(builders, (v) => {
		_.forEach(properties, (r) => {
			if (v.properties && v.properties.includes(r)) {
				bids.push(v.id)
			}
		})
	})
	bids = _.uniq(bids)
	if (bids) {
		return bids
	} else {
		return []
	}
}